<template>
  <div v-on-click-outside="outside" ref="pickerTextField">
    <field-label :field="field"></field-label>
    <v-text-field
      :value="value"
      :rules="rules"
      :disabled="field.disabled"
      outlined
      dense
      :hide-details="picker"
      clearable
      @focus="picker = true"
      @change="input"
    >
      <template slot="prepend">
        <v-card
          :color="value || 'transparent'"
          width="40"
          height="40"
          style="margin-top: -8px; border-radius: 50%"
        ></v-card>
      </template>
    </v-text-field>

    <v-expand-transition>
      <v-row no-gutters v-if="picker" class="pt-2">
        <v-spacer></v-spacer>

        <v-color-picker
          flat
          :value="value"
          @input="input"
          class="mb-5"
          :width="colorPickerWidth"
        ></v-color-picker>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'ColorPickerField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  data: () => ({
    picker: false
  }),
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    },
    colorPickerWidth() {
      return this.$refs.pickerTextField.clientWidth - 48
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value.hex || value)
    },
    outside() {
      this.picker = false
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if ((this.value === undefined) & (this.field.default !== undefined)) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>

<style>
.v-color-picker__dot {
  display: none;
}
</style>
